__turbopack_context__.v({
  "email-data": "index-module-scss-module__DUS4qq__email-data",
  "mobile-hide": "index-module-scss-module__DUS4qq__mobile-hide",
  "order-id-data": "index-module-scss-module__DUS4qq__order-id-data",
  "order-id-shop": "index-module-scss-module__DUS4qq__order-id-shop",
  "order-id-turnr": "index-module-scss-module__DUS4qq__order-id-turnr",
});
